/**
 * Sidebar navigation for the developer dashboard area.
 */

import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Code2,
  LayoutDashboard,
  Key,
  AppWindow,
  BarChart3,
  Webhook,
  CreditCard,
  Settings,
  LogOut,
  BookOpen,
  ChevronRight,
  Wallet,
} from 'lucide-react';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/dashboard/api-keys', label: 'API Keys', icon: Key },
  { to: '/dashboard/apps', label: 'Apps', icon: AppWindow },
  { to: '/dashboard/developer-tokens', label: 'Developer User Tokens', icon: Wallet },
  { to: '/dashboard/analytics', label: 'Analytics', icon: BarChart3 },
  { to: '/dashboard/webhooks', label: 'Webhooks', icon: Webhook },
  { to: '/dashboard/billing', label: 'Billing', icon: CreditCard },
  { to: '/dashboard/quickstart', label: 'Quick Start', icon: BookOpen },
  { to: '/dashboard/settings', label: 'Settings', icon: Settings },
];

export default function Sidebar() {
  const { developer, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <aside className="sidebar">
      <Link to="/" className="sidebar-brand">
        <Code2 size={28} />
        <span>token-kit</span>
      </Link>

      <nav className="sidebar-nav">
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className={`sidebar-link ${location.pathname === to ? 'active' : ''}`}
          >
            <Icon size={18} />
            <span>{label}</span>
            {location.pathname === to && <ChevronRight size={14} className="sidebar-indicator" />}
          </Link>
        ))}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-user-info">
            <span className="sidebar-user-name">{developer?.name}</span>
            <span className="sidebar-user-tier">{developer?.tier} tier</span>
          </div>
        </div>
        <button className="sidebar-link logout-link" onClick={handleLogout}>
          <LogOut size={18} />
          <span>Sign Out</span>
        </button>
      </div>
    </aside>
  );
}
